import { useCallback, useState } from 'react'
import { parseCookies } from 'nookies'

import { fetchReservationPrice } from 'features/space/services/reservationPriceApi'
import type {
  ReservationPriceResponse,
  ReservationQuoteParams,
} from 'features/space/types/reservation'

export const useReservationPrice = () => {
  const cookies = parseCookies()
  const [priceInfo, setPriceInfo] = useState<ReservationPriceResponse | null>(null)
  const [isLoading, setLoading] = useState(false)
  const [isError, setIsError] = useState(false)

  const fetchPrice = useCallback(
    async (params: ReservationQuoteParams) => {
      setLoading(true)
      setIsError(false)

      const result = await fetchReservationPrice(params, cookies.jwt_token)

      if (result.isOk) {
        setPriceInfo(result.data)
      } else {
        setPriceInfo(null)
        setIsError(true)
      }

      setLoading(false)
    },
    [cookies.jwt_token]
  )

  const resetPrice = useCallback(() => {
    setPriceInfo(null)
    setIsError(false)
  }, [])

  return {
    priceInfo,
    isLoading,
    isError,
    fetchPrice,
    resetPrice,
  }
}
